/** Grid column template shared by the user-list table header and rows (matches the mockup). */
export const USER_LIST_GRID_COLUMNS = 'minmax(0,1.6fr) minmax(0,1.2fr) 150px minmax(0,1fr)'

/** Horizontal gap between the table's columns. */
export const USER_LIST_COLUMN_GAP = '18px'
